var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-date-row"},[_c('b',[_vm._v(_vm._s(_vm.day)+" / "+_vm._s(_vm.month)+" / "+_vm._s(_vm.year))]),_c('b',[_vm._v(_vm._s(_vm.hour)+" : "+_vm._s(_vm.minute)+" : "+_vm._s(_vm.second))])])}
var staticRenderFns = []

export { render, staticRenderFns }